import React, { useState, useEffect } from "react";
import axios from 'axios';
import { CiSearch } from "react-icons/ci";
import { RiDeleteBin5Line } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const Promocode_specialOffer = () => {
  const [activeTab, setActiveTab] = useState("Promocodes");
  const [searchQuery, setSearchQuery] = useState("");
  
  const [loading, setLoading] = useState(false);

  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteApiResponse, setDeleteApiResponse] = useState(null);
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [couponType, setCouponType] = useState("");
  const [value, setValue] = useState("");
  const [limit, setLimit] = useState("");
  const[coupondate, setCoupondate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [offerText, setOfferText] = useState("");
  const [couponDate, setCouponDate] = useState("");
  const [status, setStatus] = useState("off");
  const [editingItem, setEditingItem] = useState(null);
  const [editingItemType, setEditingItemType] = useState("");

  const [promocodes, setPromocodes] = useState([]);
  const [specialOffers, setSpecialOffers] = useState([]);

  const [apiResponse, setApiResponse] = useState(null);

  const filteredData = activeTab === "Promocodes"
    ? promocodes.filter((promo) =>
        (promo.coupon?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
        (promo.coupon_code?.toLowerCase() || '').includes(searchQuery.toLowerCase())
      )
    : specialOffers.filter((offer) =>
        (offer.offer?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
        (offer.special_text?.toLowerCase() || '').includes(searchQuery.toLowerCase())
      );

  const startIndex = (currentPage - 1) * entriesPerPage;
  const paginatedData = entriesPerPage === "All"
    ? filteredData
    : filteredData.slice(startIndex, startIndex + (entriesPerPage === "All" ? filteredData.length : parseInt(entriesPerPage)));

  const totalPages = Math.ceil(filteredData.length / (entriesPerPage === "All" ? 1 : parseInt(entriesPerPage)));

  const handleSearch = (e) => setSearchQuery(e.target.value);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(e.target.value);
    setCurrentPage(1);
  };

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handlePageChange = (page) => setCurrentPage(page);

  const handleDelete = (item) => {
    setDeleteItem(item);
    setShowDeleteConfirm(true);
  };
  
  const handleEdit = (item, type) => {
    setEditingItem(item);
    setEditingItemType(type);
    setCouponCode(item.coupon_code || '');
    setCouponType(item.coupon_type || '');
    setValue(item.coupon_value?.toString() || '');
    setLimit(item.coupon_limit ? item.coupon_limit.toString() : '');
    setExpiryDate(item.coupon_date || item.coupon_expiry || '');
    if (type === "specialOffer") {
      setOfferText(item.special_text || '');
    }
    setActiveTab("Edit");
  };

  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  const confirmDelete = async () => {
    setLoading(true);
    if (activeTab === "Promocodes") {
      try {
        const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
          action: "delete_coupon",
          api_key: "1",
          coupon_id: deleteItem.id
        });
        
        if (response.data.status === "true") {
          setSuccessMessage("Delete Promocode Successfully!")

          setPromocodes(promocodes.filter(promo => promo.id !== deleteItem.id));
          setApiResponse({ status: "true", response: "Coupon deleted successfully" });
        } else {
          setApiResponse({ status: "false", response: "Failed to delete coupon" });
        }
      } catch (error) {
        console.error('Error deleting coupon:', error);
        setApiResponse({ status: "false", response: "Error deleting coupon" });
      }    finally {
      setLoading(false);
    }
    } else {
      try {
        const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
          action: "delete_special_offer",
          api_key: "1",
          specoff_id: deleteItem.id
        });
        
        if (response.data.status === "true") {
          setSuccessMessage("Delete Special Offer Successfully!")
          setSpecialOffers(specialOffers.filter(offer => offer.id !== deleteItem.id));
          setApiResponse({ status: "true", response: "Special offer deleted successfully" });
        } else {
          setApiResponse({ status: "false", response: "Failed to delete special offer" });
        }
      } catch (error) {
        console.error('Error deleting special offer:', error);
        setApiResponse({ status: "false", response: "Error deleting special offer" });
      }   finally {
      setLoading(false);
    }
    }
    setShowDeleteConfirm(false);
  };


  const handleUpdate = async () => {
    if (editingItemType === "promocode") {
      updateCoupon();
    } else {
      try {
        const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
          action: "edit_special_offer",
          api_key: "1",
          specoff_id: editingItem.id,  // Ensure you're passing the id of the item being edited
          special_text: offerText,
          coupon_type: couponType,
          coupon_value: value,
          coupon_date: expiryDate
        });
  
        setApiResponse(response.data);
        if (response.data.status === "true") {
          setSuccessMessage("Update Promocode Successfully!")
          setSpecialOffers(specialOffers.map(offer =>
            offer.id === editingItem.id ? {
              ...offer,
              special_text: offerText,
              coupon_type: couponType,
              coupon_value: parseFloat(value),
              coupon_date: expiryDate
            } : offer
          ));
          setEditingItem(null);  // Clear the editing state
          setEditingItemType("");  // Reset editing type
          setActiveTab("Special Offer List");  // Switch to the appropriate tab
        }
      } catch (error) {
        console.error('Error updating special offer:', error);
        setApiResponse({ status: "false", response: "Error updating special offer" });
      }
    }
  };
  

  const addCoupon = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
        action: "add_coupon",
        
        api_key: "1",
        coupon_code: couponCode,
        coupon_type: couponType,
        coupon_limit: limit,
        coupon_value: value,
        coupon_expiry: expiryDate,
        status: status
      });
      setApiResponse(response.data);
      if (response.data.status === "true") {
        setSuccessMessage("Add Promocode Successfully!")
        setPromocodes([...promocodes, {
          id: response.data.coupon_id,
          coupon: couponCode,
          coupon_code: couponCode,
          coupon_type: couponType,
          coupon_limit: limit,
          coupon_used: 0,
          coupon_value: value,
          coupon_expiry: expiryDate,
          status: status
        }]);
        resetForm();
      }
    } catch (error) {
      console.error('Error adding coupon:', error);
      setApiResponse({ status: "false", response: "Error adding coupon" });
    }   finally {
      setLoading(false);
    }
  };

  const addSpecialOffer = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
        action: "add_special_offer",
        api_key: "1",
        special_text: offerText,
        coupon_type: couponType,
        coupon_value: value,
        coupon_expiry: expiryDate,
        coupon_date: couponDate
      });
      setApiResponse(response.data);
      if (response.data.status === "true") {
        setSuccessMessage("Add Special Offer Successfully!")
        setSpecialOffers([...specialOffers, {
          id: specialOffers.length + 1, // This should be replaced with the actual ID from the API response
          offer: offerText,
          text: offerText,
          code: couponCode,
          type: couponType,
          value: parseInt(value),
          date: expiryDate
        }]);
        resetForm();
      }
    } catch (error) {
      console.error('Error adding special offer:', error);
      setApiResponse({ status: "false", response: "Error adding special offer" });
    }   finally {
      setLoading(false);
    }
  };

  const updateCoupon = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
        action: "edit_coupon",
        api_key: "1",
        coupon_id: editingItem.id,
        coupon_code: couponCode,
        coupon_type: couponType,
        coupon_limit: limit,
        coupon_value: value,
        coupon_expiry: expiryDate,
        status:status
      });
      setApiResponse(response.data);
      if (response.data.status === "true") {
        setSuccessMessage("Update Coupon Successfully!")
        setPromocodes(promocodes.map(coupon =>
          coupon.id === editingItem.id ? {
            ...coupon,
            coupon: couponCode,
            coupon_code: couponCode,
            coupon_type: couponType,
            coupon_limit: limit,
            coupon_value: value,
            coupon_expiry: expiryDate
          } : coupon
        ));
        setEditingItem(null);
        setEditingItemType("");
        setActiveTab("Promocodes");
      }
    } catch (error) {
      console.error('Error updating coupon:', error);
      setApiResponse({ status: "false", response: "Error updating coupon" });
    }   finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    
    e.preventDefault();
    if (activeTab === "Add New") {
      addCoupon();
    } else if (activeTab === "Add Special Offer") {
      addSpecialOffer();
    }
  };

  const resetForm = () => {
    setCouponCode("");
    setCouponType("");
    setValue("");
    setLimit("");
    setExpiryDate("");
    setOfferText("");
    setCouponDate("");
    setStatus("off");
  };

  useEffect(() => {
    if (apiResponse) {
      console.log('API Response:', apiResponse);
    }
  }, [apiResponse]);

  useEffect(() => {
    const fetchPromocodes = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
          action: "get_all_coupons",
          api_key: "1"
        });

        if (response.data.status === "true") {
          const formattedCoupons = response.data.data.map(coupon => ({
            id: coupon.id,
            coupon: coupon.coupon_code,
            coupon_code: coupon.coupon_code,
            coupon_type: coupon.coupon_type === "P" ? "Percentage" : "Flat",
            coupon_limit: parseInt(coupon.coupon_limit),
            coupon_used: parseInt(coupon.coupon_used),
            coupon_value: parseFloat(coupon.coupon_value),
            coupon_expiry: coupon.coupon_expiry
          }));
          setPromocodes(formattedCoupons);
        } else {
          console.error('Failed to fetch promocodes:', response.data.response);
        }
      } catch (error) {
        console.error('Error fetching promocodes:', error);
      }   finally {
      setLoading(false);
    }
    };

    fetchPromocodes();
  }, []);

  useEffect(() => {
    const fetchSpecialOffers = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${BaseUrl}/backend/api/promocode.php`, {
          action: "get_all_special_offers",
          api_key: "1"
        });

        if (response.data.status === "true") {
          const formattedOffers = response.data.data.map(offer => ({
            id: offer.id,
            offer: offer.offer,
            special_text: offer.special_text,
            coupon_code: offer.coupon_code,
            coupon_type: offer.coupon_type === "P" ? "Percentage" : "Flat",
            coupon_value: parseFloat(offer.coupon_value),
            coupon_date: offer.coupon_date
          }));
          setSpecialOffers(formattedOffers);
        } else {
          console.error('Failed to fetch special offers:', response.data.response);
        }
      } catch (error) {
        console.error('Error fetching special offers:', error);
      }   finally {
      setLoading(false);
    }
    };

    fetchSpecialOffers();
  }, []);

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8 bg-white xl:px-52">
                          {successMessage && (
                          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
                            <span className="block sm:inline">{successMessage}</span>
                          </div>
                        )}

                        {error && (
                          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
                            <span className="block sm:inline">{error}</span>
                          </div>
                        )}
                      <div className="flex flex-nowrap justify-between border-b sm:border-b-4 md:border-b-8 border-gray-300 pb-4 mb-6 overflow-x-auto">
              {/* Desktop Tabs (Visible on larger screens) */}
            <div className="hidden sm:flex flex-row w-full gap-2">
              {[
                "Promocodes",
                "Add New",
                "Add Special Offer",
                "Special Offer List",
                ...(activeTab === "Edit" ? ["Edit"] : []),
              ].map((tab) => (
                <button
                  key={tab}
                  className={`flex-1 text-center px-2 sm:px-4 py-2 text-nowrap text-xs sm:text-sm font-medium rounded-lg transition-colors duration-300 ease-in-out ${
                    activeTab === tab
                      ? "bg-blue-500 border-b-4 border-blue-500 font-semibold text-white"
                      : "border-b-4 border-transparent text-gray-600 hover:text-blue-400 hover:border-blue-300 bg-slate-50"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Mobile Dropdown (Visible on smaller screens) */}
            <div className="sm:hidden w-full">
              <select
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
                className="w-full px-4 py-2 text-xs sm:text-sm font-medium rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-slate-50"
              >
                {[
                  "Promocodes",
                  "Add New",
                  "Add Special Offer",
                  "Special Offer List",
                  ...(activeTab === "Edit" ? ["Edit"] : []),
                ].map((tab) => (
                  <option key={tab} value={tab}>
                    {tab}
                  </option>
                ))}
              </select>
            </div>
            </div>


                  <div className="p-2 sm:p-6">
                  {activeTab === "Promocodes" && (
              <div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Promocodes</h2>

                <div className="flex flex-col sm:flex-row items-center gap-4 mb-4">
                  <div className="relative w-full sm:w-80 md:w-96">
                    <input
                      type="text"
                      placeholder="Search Promocodes..."
                      value={searchQuery}
                      onChange={handleSearch}
                      className="p-3 w-full rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
                    />
                    <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="flex items-center gap-1 sm:mt-0">
                    <span>Show</span>
                    <select
                      value={entriesPerPage}
                      onChange={handleEntriesChange}
                      className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value="All">All</option>
                    </select>
                    <span>entries</span>
                  </div>
                </div>

                {/* Responsive Table for Desktop, Cards for Mobile */}
                <div className="overflow-x-auto sm:hidden">
                  {/* Mobile Card View */}
                  <div className="grid grid-cols-1 gap-4">
                    {paginatedData.map((promo) => (
                      <div key={promo.id} className="border rounded-lg p-4 shadow-md bg-white">
                        <div className="text-xl font-semibold">{promo.coupon_code}</div>
                        <div className="text-sm text-gray-600 mt-2">Coupon Type: {promo.coupon_type}</div>
                        <div className="text-sm text-gray-600 mt-2">Coupon Limit: {promo.coupon_limit}</div>
                        <div className="text-sm text-gray-600 mt-2">Coupon Used: {promo.coupon_used}</div>
                        <div className="text-sm text-gray-600 mt-2">Coupon Value: {promo.coupon_value}</div>
                        <div className="text-sm text-gray-600 mt-2">Expiry Date: {promo.coupon_expiry}</div>
                        <div className="flex gap-2 mt-4">
                          <button
                            onClick={() => handleEdit(promo, "promocode")}
                            className="text-green-800 hover:text-green-700"
                          >
                            <BiSolidEdit className="text-2xl" />
                          </button>
                          <button
                            onClick={() => handleDelete(promo)}
                            className="text-red-500 hover:text-red-700"
                          >
                            <RiDeleteBin5Line className="text-2xl" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="hidden sm:block">
                  {/* Desktop Table View */}
                  <div className="overflow-x-auto">
                    <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg">
                      <thead>
                        <tr className="text-left bg-gray-100">
                          <th className="px-4 py-2 border-b">Id</th>
                          <th className="px-4 py-2 border-b">Coupon Code</th>
                          <th className="px-4 py-2 border-b">Coupon Type</th>
                          <th className="px-4 py-2 border-b">Coupon Limit</th>
                          <th className="px-4 py-2 border-b">Coupon Used</th>
                          <th className="px-4 py-2 border-b">Coupon Value</th>
                          <th className="px-4 py-2 border-b">Expiry Date</th>
                          <th className="px-4 py-2 border-b">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((promo) => (
                          <tr key={promo.id} className="border-b hover:bg-gray-50">
                            <td className="px-4 py-2">{promo.id}</td>
                            <td className="px-4 py-2">{promo.coupon_code}</td>
                            <td className="px-4 py-2">{promo.coupon_type}</td>
                            <td className="px-4 py-2">{promo.coupon_limit}</td>
                            <td className="px-4 py-2">{promo.coupon_used}</td>
                            <td className="px-4 py-2">{promo.coupon_value}</td>
                            <td className="px-4 py-2">{promo.coupon_expiry}</td>
                            <td className="px-4 py-2">
                              <button
                                onClick={() => handleEdit(promo, "promocode")}
                                className="text-green-800 hover:text-green-700 mr-2"
                              >
                                <BiSolidEdit className="text-3xl" />
                              </button>
                              <button
                                onClick={() => handleDelete(promo)}
                                className="text-red-500 hover:text-red-700"
                              >
                                <RiDeleteBin5Line className="text-3xl" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="flex items-center justify-between mt-4">
                  <div className="text-sm text-gray-600">
                    <span>
                      Showing {startIndex + 1} to {Math.min(startIndex + (entriesPerPage === "All" ? filteredData.length : parseInt(entriesPerPage)), filteredData.length)} of{" "}
                      {filteredData.length} entries
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    {entriesPerPage !== "All" && (
                      <div className="flex items-center">
                        <button
                          onClick={handlePrevPage}
                          disabled={currentPage === 1}
                          className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
                        >
                          Previous
                        </button>
                        {[...Array(totalPages).keys()].map((page) => (
                          <button
                            key={`page-${page + 1}`}
                            onClick={() => handlePageChange(page + 1)}
                            className={`px-4 py-2 border ${currentPage === page + 1 ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-gray-300"}`}
                          >
                            {page + 1}
                          </button>
                        ))}
                        <button
                          onClick={handleNextPage}
                          disabled={currentPage === totalPages}
                          className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}


                    {activeTab === "Add New" && (
                      <div>
                        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Add New Promocode</h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Coupon Code</label>
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter coupon code"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Coupon Type</label>
                            <select
                              value={couponType}
                              onChange={(e) => setCouponType(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              required
                            >
                              <option value="">Select type</option>
                              <option value="P">Percentage</option>
                              <option value="F">Flat</option>
                            </select>
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Value</label>
                            <input
                              type="number"
                              value={value}
                              onChange={(e) => setValue(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter value"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Limit</label>
                            <input
                              type="number"
                              value={limit}
                              onChange={(e) => setLimit(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter limit"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Expiry Date</label>
                            <input
                              type="date"
                              value={expiryDate}
                              onChange={(e) => setExpiryDate(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Status</label>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                    required
                  >
                    <option value="on">on</option>
                    <option value="off">off</option>
                  </select>
                </div>
                          <div>
                            <button
                              type="submit"
                              className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-auto"
                            >
                              Save
                            </button>
                          </div>
                        </form>
                        {apiResponse && (
                          <div className={`mt-4 p-4 rounded-lg ${apiResponse.status === "true" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
                            {apiResponse.response}
                          </div>
                        )}
                      </div>
                    )}

                    {activeTab === "Add Special Offer" && (
                      <div>
                        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Add Special Offer</h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Special Text</label>
                            <input
                              type="text"
                              value={offerText}
                              onChange={(e) => setOfferText(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter special text"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Coupon Type</label>
                            <select
                              value={couponType}
                              onChange={(e) => setCouponType(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              required
                            >
                              <option value="">Select type</option>
                              <option value="P">Percentage</option>
                              <option value="F">Flat</option>
                            </select>
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Value</label>
                            <input
                              type="number"
                              value={value}
                              onChange={(e) => setValue(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter value"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Coupon Date</label>
                            <input
                              type="date"
                              value={couponDate}
                              onChange={(e) => setCouponDate(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Limit</label>
                            <input
                              type="number"
                              value={limit}
                              onChange={(e) => setLimit(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter limit"
                              required
                            />
                          </div>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Expiry Date</label>
                            <input
                              type="date"
                              value={expiryDate}
                              onChange={(e) => setExpiryDate(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              required
                            />
                          </div>
                          <div>
                            <button
                              type="submit"
                              className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-auto"
                            >
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    )}

                  {activeTab === "Special Offer List" && (
                    <div>
                      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Special Offer List</h2>

                      <div className="flex flex-col sm:flex-row items-center gap-4 mb-4">
                        <div className="relative w-full sm:w-80 md:w-96">
                          <input
                            type="text"
                            placeholder="Search Special Offers..."
                            value={searchQuery}
                            onChange={handleSearch}
                            className="p-3 w-full rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
                          />
                          <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                        </div>
                        <div className="flex items-center gap-1 sm:mt-0">
                          <span>Show</span>
                          <select
                            value={entriesPerPage}
                            onChange={handleEntriesChange}
                            className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value="All">All</option>
                          </select>
                          <span>entries</span>
                        </div>
                      </div>

                      {/* ✅ Mobile View (Cards) */}
                      <div className="sm:hidden grid grid-cols-1 gap-4">
                        {paginatedData.map((offer) => (
                          <div key={offer.id} className="border rounded-lg p-4 shadow-md bg-white">
                            <div className="text-lg font-semibold">{offer.special_text || "N/A"}</div>
                            <div className="text-sm text-gray-600">Coupon Type: {offer.coupon_type || "N/A"}</div>
                            <div className="text-sm text-gray-600">Coupon Value: {offer.coupon_value || "N/A"}</div>
                            <div className="text-sm text-gray-600">Expiry Date: {offer.coupon_date || "N/A"}</div>
                            <div className="flex gap-2 mt-3">
                              {/* <button onClick={() => handleEdit(offer, "specialOffer")} className="text-green-800 hover:text-green-700">
                                <BiSolidEdit className="text-2xl" />
                              </button> */}
                              <button onClick={() => handleDelete(offer)} className="text-red-500 hover:text-red-700">
                                <RiDeleteBin5Line className="text-2xl" />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* ✅ Tablet & Laptop View (Table) */}
                      <div className="hidden sm:block overflow-x-auto">
                        <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg">
                          <thead>
                            <tr className="text-left bg-gray-100">
                              <th className="px-4 py-2 border-b">Offer</th>
                              <th className="px-4 py-2 border-b">Special Offer Text</th>
                              <th className="px-4 py-2 border-b">Coupon Type</th>
                              <th className="px-4 py-2 border-b">Coupon Value</th>
                              <th className="px-4 py-2 border-b">Expiry Date</th>
                              <th className="px-4 py-2 border-b">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedData.map((offer) => (
                              <tr key={offer.id} className="border-b hover:bg-gray-50">
                                <td className="px-4 py-2">{offer.id || "N/A"}</td>
                                <td className="px-4 py-2">{offer.special_text || "N/A"}</td>
                                <td className="px-4 py-2">{offer.coupon_type || "N/A"}</td>
                                <td className="px-4 py-2">{offer.coupon_value || "N/A"}</td>
                                <td className="px-4 py-2">{offer.coupon_date || "N/A"}</td>
                                <td className="px-4 py-2">
                                  {/* <button onClick={() => handleEdit(offer, "specialOffer")} className="text-green-800 hover:text-green-700 mr-2">
                                    <BiSolidEdit className="text-3xl" />
                                  </button> */}
                                  <button onClick={() => handleDelete(offer)} className="text-red-500 hover:text-red-700">
                                    <RiDeleteBin5Line className="text-3xl" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="flex items-center justify-between mt-4">
                        <div className="text-sm text-gray-600">
                          <span>
                            Showing {startIndex + 1} to {Math.min(startIndex + (entriesPerPage === "All" ? filteredData.length : parseInt(entriesPerPage)), filteredData.length)} of{" "}
                            {filteredData.length} entries
                          </span>
                        </div>
                        <div className="flex items-center gap-4">
                          {entriesPerPage !== "All" && (
                            <div className="flex items-center">
                              <button
                                onClick={handlePrevPage}
                                disabled={currentPage === 1}
                                className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
                              >
                                Previous
                              </button>
                              {[...Array(totalPages).keys()].map((page) => (
                                <button
                                  key={`page-${page + 1}`}
                                  onClick={() => handlePageChange(page + 1)}
                                  className={`px-4 py-2 border ${currentPage === page + 1 ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-gray-300"}`}
                                >
                                  {page + 1}
                                </button>
                              ))}
                              <button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                                className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                {activeTab === "Edit" && editingItem && (
                  <div className="bg-white rounded-lg shadow-sm p-6">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                      Edit {editingItemType === "promocode" ? "Promocode" : "Special Offer"}
                    </h2>
                    <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }} className="space-y-6">
                      {editingItemType === "specialOffer" && (
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                          <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
                            Special Text
                          </label>
                          <input
                            type="text"
                            value={offerText}
                            onChange={(e) => setOfferText(e.target.value)}
                            className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                            placeholder="Enter special text"
                            required
                          />
                        </div>
                      )}

                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                        <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
                          Coupon Type
                        </label>
                        <select
                          value={couponType}
                          onChange={(e) => setCouponType(e.target.value)}
                          className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration200"
                          required
                        >
                          <option value="P">Percentage</option>
                          <option value="F">Flat</option>
                        </select>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Coupon Code</label>
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter coupon code"
                              required
                            />
                          </div>


                          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                            <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Limit</label>
                            <input
                              type="number"
                              value={limit}
                              onChange={(e) => setLimit(e.target.value)}
                              className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                              placeholder="Enter limit"
                              required
                            />
                          </div>

                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                        <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
                          Value
                        </label>
                        <input
                          type="number"
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                          className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                          placeholder="Enter value"
                          required
                        />
                      </div>

                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                        <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
                          {editingItemType === "specialOffer" ? "Coupon Date" : "Expiry Date"}
                        </label>
                        <input
                          type="date"
                          value={expiryDate}
                          onChange={(e) => setExpiryDate(e.target.value)}
                          className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                          required
                        />
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label className="text-sm font-medium text-gray-600 w-full sm:w-36">Status</label>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64"
                    required
                  >
                    <option value="on">on</option>
                    <option value="off">off</option>
                  </select>
                </div>

                      <div className="pt-4">
                        <button
                          type="submit"
                          className="px-6 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 transition-all duration-200 font-medium"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>

              {showDeleteConfirm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 transform transition-all duration-300 scale-100">
                    <div className="p-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4">
                        Are you sure you want to delete this item?
                      </h3>
                      <div className="flex justify-end gap-4">
                        <button
                          onClick={() => setShowDeleteConfirm(false)}
                          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={confirmDelete}
                          className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors duration-200"
                        >
                          Confirm
                        </button>
                      </div>
                      {deleteApiResponse && (
                        <div className={`mt-4 p-2 rounded ${deleteApiResponse.status === "true" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
                          {deleteApiResponse.response}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
    </div>
     
  </div>
  );
};

export default Promocode_specialOffer;



// import axios from 'axios';
// import { CiSearch } from "react-icons/ci";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import { BiSolidEdit } from "react-icons/bi";

// const Promocode_specialOffer = () => {
//   const [activeTab, setActiveTab] = useState("Promocodes");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [deleteItem, setDeleteItem] = useState(null);
//   const [deleteApiResponse, setDeleteApiResponse] = useState(null);

//   const [couponCode, setCouponCode] = useState("");
//   const [couponType, setCouponType] = useState("");
//   const [value, setValue] = useState("");
//   const [limit, setLimit] = useState("");
//   const [expiryDate, setExpiryDate] = useState("");
//   const [offerText, setOfferText] = useState("");
//   const [couponDate, setCouponDate] = useState("");

//   const [editingItem, setEditingItem] = useState(null);
//   const [editingItemType, setEditingItemType] = useState("");

//   const [promocodes, setPromocodes] = useState([]);
//   const [specialOffers, setSpecialOffers] = useState([]);

//   const [apiResponse, setApiResponse] = useState(null);

//   const filteredData = activeTab === "Promocodes"
//     ? promocodes.filter((promo) =>
//         (promo.coupon?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
//         (promo.coupon_code?.toLowerCase() || '').includes(searchQuery.toLowerCase())
//       )
//     : specialOffers.filter((offer) =>
//         (offer.offer?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
//         (offer.special_text?.toLowerCase() || '').includes(searchQuery.toLowerCase())
//       );

//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const paginatedData = entriesPerPage === "All"
//     ? filteredData
//     : filteredData.slice(startIndex, startIndex + (entriesPerPage === "All" ? filteredData.length : parseInt(entriesPerPage)));

//   const totalPages = Math.ceil(filteredData.length / (entriesPerPage === "All" ? 1 : parseInt(entriesPerPage)));

//   const handleSearch = (e) => setSearchQuery(e.target.value);

//   const handleEntriesChange = (e) => {
//     setEntriesPerPage(e.target.value);
//     setCurrentPage(1);
//   };

//   const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   const handlePageChange = (page) => setCurrentPage(page);

//   const handleDelete = (item) => {
//     setDeleteItem(item);
//     setShowDeleteConfirm(true);
//   };
  
//   const handleEdit = (item, type) => {
//     setEditingItem(item);
//     setEditingItemType(type);
//     setCouponCode(item.coupon_code || '');
//     setCouponType(item.coupon_type || '');
//     setValue(item.coupon_value?.toString() || '');
//     setLimit(item.coupon_limit ? item.coupon_limit.toString() : '');
//     setExpiryDate(item.coupon_date || item.coupon_expiry || '');
//     if (type === "specialOffer") {
//       setOfferText(item.special_text || '');
//     }
//     setActiveTab("Edit");
//   };

//   const confirmDelete = async () => {
//     if (activeTab === "Promocodes") {
//       try {
//         const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//           action: "delete_coupon",
//           api_key: "1",
//           coupon_id: deleteItem.id
//         });
        
//         if (response.data.status === "true") {
//           setPromocodes(promocodes.filter(promo => promo.id !== deleteItem.id));
//           setApiResponse({ status: "true", response: "Coupon deleted successfully" });
//         } else {
//           setApiResponse({ status: "false", response: "Failed to delete coupon" });
//         }
//       } catch (error) {
//         console.error('Error deleting coupon:', error);
//         setApiResponse({ status: "false", response: "Error deleting coupon" });
//       }
//     } else {
//       try {
//         const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//           action: "delete_special_offer",
//           api_key: "1",
//           specoff_id: deleteItem.id
//         });
        
//         if (response.data.status === "true") {
//           setSpecialOffers(specialOffers.filter(offer => offer.id !== deleteItem.id));
//           setApiResponse({ status: "true", response: "Special offer deleted successfully" });
//         } else {
//           setApiResponse({ status: "false", response: "Failed to delete special offer" });
//         }
//       } catch (error) {
//         console.error('Error deleting special offer:', error);
//         setApiResponse({ status: "false", response: "Error deleting special offer" });
//       }
//     }
//     setShowDeleteConfirm(false);
//   };


//   const handleUpdate = async () => {
//     if (editingItemType === "promocode") {
//       updateCoupon();
//     } else {
//       try {
//         const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//           action: "edit_special_offer",
//           api_key: "1",
//           specoff_id: editingItem.id,  // Ensure you're passing the id of the item being edited
//           special_text: offerText,
//           coupon_type: couponType,
//           coupon_value: value,
//           coupon_date: expiryDate
//         });
  
//         setApiResponse(response.data);
//         if (response.data.status === "true") {
//           setSpecialOffers(specialOffers.map(offer =>
//             offer.id === editingItem.id ? {
//               ...offer,
//               special_text: offerText,
//               coupon_type: couponType,
//               coupon_value: parseFloat(value),
//               coupon_date: expiryDate
//             } : offer
//           ));
//           setEditingItem(null);  // Clear the editing state
//           setEditingItemType("");  // Reset editing type
//           setActiveTab("Special Offer List");  // Switch to the appropriate tab
//         }
//       } catch (error) {
//         console.error('Error updating special offer:', error);
//         setApiResponse({ status: "false", response: "Error updating special offer" });
//       }
//     }
//   };
  

//   const addCoupon = async () => {
//     try {
//       const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//         action: "add_coupon",
        
//         api_key: "1",
//         coupon_code: couponCode,
//         coupon_type: couponType,
//         coupon_limit: limit,
//         coupon_value: value,
//         coupon_expiry: expiryDate,
//         status: "active"
//       });
//       setApiResponse(response.data);
//       if (response.data.status === "true") {
//         setPromocodes([...promocodes, {
//           id: response.data.coupon_id,
//           coupon: couponCode,
//           coupon_code: couponCode,
//           coupon_type: couponType,
//           coupon_limit: limit,
//           coupon_used: 0,
//           coupon_value: value,
//           coupon_expiry: expiryDate
//         }]);
//         resetForm();
//       }
//     } catch (error) {
//       console.error('Error adding coupon:', error);
//       setApiResponse({ status: "false", response: "Error adding coupon" });
//     }
//   };

//   const addSpecialOffer = async () => {
//     try {
//       const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//         action: "add_special_offer",
//         api_key: "1",
//         special_text: offerText,
//         coupon_type: couponType,
//         coupon_value: value,
//         coupon_expiry: expiryDate,
//         coupon_date: couponDate
//       });
//       setApiResponse(response.data);
//       if (response.data.status === "true") {
//         setSpecialOffers([...specialOffers, {
//           id: specialOffers.length + 1, // This should be replaced with the actual ID from the API response
//           offer: offerText,
//           text: offerText,
//           code: couponCode,
//           type: couponType,
//           value: parseInt(value),
//           date: expiryDate
//         }]);
//         resetForm();
//       }
//     } catch (error) {
//       console.error('Error adding special offer:', error);
//       setApiResponse({ status: "false", response: "Error adding special offer" });
//     }
//   };

//   const updateCoupon = async () => {
//     try {
//       const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//         action: "edit_coupon",
//         api_key: "1",
//         coupon_id: editingItem.id,
//         coupon_code: couponCode,
//         coupon_type: couponType,
//         coupon_limit: limit,
//         coupon_value: value,
//         coupon_expiry: expiryDate,
//         status: "active"
//       });
//       setApiResponse(response.data);
//       if (response.data.status === "true") {
//         setPromocodes(promocodes.map(coupon =>
//           coupon.id === editingItem.id ? {
//             ...coupon,
//             coupon: couponCode,
//             coupon_code: couponCode,
//             coupon_type: couponType,
//             coupon_limit: limit,
//             coupon_value: value,
//             coupon_expiry: expiryDate
//           } : coupon
//         ));
//         setEditingItem(null);
//         setEditingItemType("");
//         setActiveTab("Promocodes");
//       }
//     } catch (error) {
//       console.error('Error updating coupon:', error);
//       setApiResponse({ status: "false", response: "Error updating coupon" });
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (activeTab === "Add New") {
//       addCoupon();
//     } else if (activeTab === "Add Special Offer") {
//       addSpecialOffer();
//     }
//   };

//   const resetForm = () => {
//     setCouponCode("");
//     setCouponType("");
//     setValue("");
//     setLimit("");
//     setExpiryDate("");
//     setOfferText("");
//     setCouponDate("");
//   };

//   useEffect(() => {
//     if (apiResponse) {
//       console.log('API Response:', apiResponse);
//     }
//   }, [apiResponse]);

//   useEffect(() => {
//     const fetchPromocodes = async () => {
//       try {
//         const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//           action: "get_all_coupons",
//           api_key: "1"
//         });

//         if (response.data.status === "true") {
//           const formattedCoupons = response.data.data.map(coupon => ({
//             id: coupon.id,
//             coupon: coupon.coupon_code,
//             coupon_code: coupon.coupon_code,
//             coupon_type: coupon.coupon_type === "P" ? "Percentage" : "Flat",
//             coupon_limit: parseInt(coupon.coupon_limit),
//             coupon_used: parseInt(coupon.coupon_used),
//             coupon_value: parseFloat(coupon.coupon_value),
//             coupon_expiry: coupon.coupon_expiry
//           }));
//           setPromocodes(formattedCoupons);
//         } else {
//           console.error('Failed to fetch promocodes:', response.data.response);
//         }
//       } catch (error) {
//         console.error('Error fetching promocodes:', error);
//       }
//     };

//     fetchPromocodes();
//   }, []);

//   useEffect(() => {
//     const fetchSpecialOffers = async () => {
//       try {
//         const response = await axios.post('http://10.27.1.112:80/megaclean/backend/api/promocode.php', {
//           action: "get_all_special_offers",
//           api_key: "1"
//         });

//         if (response.data.status === "true") {
//           const formattedOffers = response.data.data.map(offer => ({
//             id: offer.id,
//             offer: offer.offer,
//             special_text: offer.special_text,
//             coupon_code: offer.coupon_code,
//             coupon_type: offer.coupon_type === "P" ? "Percentage" : "Flat",
//             coupon_value: parseFloat(offer.coupon_value),
//             coupon_date: offer.coupon_date
//           }));
//           setSpecialOffers(formattedOffers);
//         } else {
//           console.error('Failed to fetch special offers:', response.data.response);
//         }
//       } catch (error) {
//         console.error('Error fetching special offers:', error);
//       }
//     };

//     fetchSpecialOffers();
//   }, []);

//   return (
//     <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8 bg-white xl:px-52">
//       <div className="flex flex-nowrap justify-between border-b sm:border-b-4 md:border-b-8 border-gray-300 pb-4 mb-6 overflow-x-auto">
//         <div className="flex flex-row w-full gap-2">
//           {[
//             "Promocodes",
//             "Add New",
//             "Add Special Offer",
//             "Special Offer List",
//             ...(activeTab === "Edit" ? ["Edit"] : [])
//           ].map((tab) => (
//             <button
//               key={tab}
//               className={`flex-1 text-center px-2 sm:px-4 py-2 text-nowrap text-xs sm:text-sm font-medium rounded-lg transition-colors duration-300 ease-in-out ${activeTab === tab
//                   ? "bg-blue-500 border-b-4 border-blue-500 font-semibold text-white"
//                   : "border-b-4 border-transparent text-gray-600 hover:text-blue-400 hover:border-blue-300 bg-slate-50"
//                 }`}
//               onClick={() => setActiveTab(tab)}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="p-2 sm:p-6">
//         {activeTab === "Promocodes" && (
//           <div>
//             <h2 className="text-2xl font-semibold text-gray-800 mb-4">Promocodes</h2>

//             <div className="flex items-center gap-4 mb-4 ">
//               <div className="relative">
//                 <input
//                   type="text"
//                   placeholder="Search Promocodes..."
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="p-3 lg:w-full sm:w-80 md:w-96 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
//                 />
//                 <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
//               </div>
//               <div className="flex items-center gap-1 sm:mt-0">
//                 <span>Show</span>
//                 <select
//                   value={entriesPerPage}
//                   onChange={handleEntriesChange}
//                   className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                   <option value="All">All</option>
//                 </select>
//                 <span>entries</span>
//               </div>
//             </div>

//             <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg hidden sm:table">
//               <thead>
//                 <tr className="text-left bg-gray-100">
//                   <th className="px-4 py-2 border-b">Id</th>
//                   <th className="px-4 py-2 border-b">Coupon Code</th>
//                   <th className="px-4 py-2 border-b">Coupon Type</th>
//                   <th className="px-4 py-2 border-b">Coupon Limit</th>
//                   <th className="px-4 py-2 border-b">Coupon Used</th>
//                   <th className="px-4 py-2 border-b">Coupon Value</th>
//                   <th className="px-4 py-2 border-b">Expiry Date</th>
//                   <th className="px-4 py-2 border-b">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((promo) => (
//                   <tr key={promo.id} className="border-b hover:bg-gray-50">
//                     <td className="px-4 py-2">{promo.id}</td>
//                     <td className="px-4 py-2">{promo.coupon_code}</td>
//                     <td className="px-4 py-2">{promo.coupon_type}</td>
//                     <td className="px-4 py-2">{promo.coupon_limit}</td>
//                     <td className="px-4 py-2">{promo.coupon_used}</td>
//                     <td className="px-4 py-2">{promo.coupon_value}</td>
//                     <td className="px-4 py-2">{promo.coupon_expiry}</td>
//                     <td className="px-4 py-2">
//                       <button
//                         onClick={() => handleEdit(promo, "promocode")}
//                         className="text-green-800 hover:text-green-700 mr-2"
//                       >
//                         <BiSolidEdit className="text-3xl" />
//                       </button>
//                       <button
//                         onClick={() => handleDelete(promo)}
//                         className="text-red-500 hover:text-red-700"
//                       >
//                         <RiDeleteBin5Line className="text-3xl" />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             <div className="flex items-center justify-between mt-4">
//               <div className="text-sm text-gray-600">
//                 <span>
//                   Showing {startIndex + 1} to {Math.min(startIndex + (entriesPerPage === "All" ? filteredData.length : parseInt(entriesPerPage)), filteredData.length)} of{" "}
//                   {filteredData.length} entries
//                 </span>
//               </div>
//               <div className="flex items-center gap-4">
//                 {entriesPerPage !== "All" && (
//                   <div className="flex items-center">
//                     <button
//                       onClick={handlePrevPage}
//                       disabled={currentPage === 1}
//                       className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
//                     >
//                       Previous
//                     </button>
//                     {[...Array(totalPages).keys()].map((page) => (
//                       <button
//                         key={`page-${page + 1}`}
//                         onClick={() => handlePageChange(page + 1)}
//                         className={`px-4 py-2 border ${currentPage === page + 1
//                             ? "bg-blue-500 text-white"
//                             : "bg-gray-200 hover:bg-gray-300"
//                           }`}
//                       >
//                         {page + 1}
//                       </button>
//                     ))}
//                     <button
//                       onClick={handleNextPage}
//                       disabled={currentPage === totalPages}
//                       className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         {activeTab === "Add New" && (
//           <div>
//             <h2 className="text-2xl font-semibold text-gray-800 mb-4">Add New Promocode</h2>
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Coupon Code</label>
//                 <input
//                   type="text"
//                   value={couponCode}
//                   onChange={(e) => setCouponCode(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   placeholder="Enter coupon code"
//                   required
//                 />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Coupon Type</label>
//                 <select
//                   value={couponType}
//                   onChange={(e) => setCouponType(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   required
//                 >
//                   <option value="">Select type</option>
//                   <option value="P">Percentage</option>
//                   <option value="F">Flat</option>
//                 </select>
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Value</label>
//                 <input
//                   type="number"
//                   value={value}
//                   onChange={(e) => setValue(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   placeholder="Enter value"
//                   required
//                 />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Limit</label>
//                 <input
//                   type="number"
//                   value={limit}
//                   onChange={(e) => setLimit(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   placeholder="Enter limit"
//                   required
//                 />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Expiry Date</label>
//                 <input
//                   type="date"
//                   value={expiryDate}
//                   onChange={(e) => setExpiryDate(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   required
//                 />
//               </div>
//               <div>
//                 <button
//                   type="submit"
//                   className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-auto"
//                 >
//                   Save
//                 </button>
//               </div>
//             </form>
//             {apiResponse && (
//               <div className={`mt-4 p-4 rounded-lg ${apiResponse.status === "true" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
//                 {apiResponse.response}
//               </div>
//             )}
//           </div>
//         )}

//         {activeTab === "Add Special Offer" && (
//           <div>
//             <h2 className="text-2xl font-semibold text-gray-800 mb-4">Add Special Offer</h2>
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Special Text</label>
//                 <input
//                   type="text"
//                   value={offerText}
//                   onChange={(e) => setOfferText(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   placeholder="Enter special text"
//                   required
//                 />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Coupon Type</label>
//                 <select
//                   value={couponType}
//                   onChange={(e) => setCouponType(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   required
//                 >
//                   <option value="">Select type</option>
//                   <option value="P">Percentage</option>
//                   <option value="F">Flat</option>
//                 </select>
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Value</label>
//                 <input
//                   type="number"
//                   value={value}
//                   onChange={(e) => setValue(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   placeholder="Enter value"
//                   required
//                 />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="text-sm font-medium text-gray-600 w-36">Coupon Date</label>
//                 <input
//                   type="date"
//                   value={couponDate}
//                   onChange={(e) => setCouponDate(e.target.value)}
//                   className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
//                   required
//                 />
//               </div>
//               <div>
//                 <button
//                   type="submit"
//                   className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-auto"
//                 >
//                   Save
//                 </button>
//               </div>
//             </form>
//             {apiResponse && (
//               <div className={`mt-4 p-4 rounded-lg ${apiResponse.status === "true" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
//                 {apiResponse.response}
//               </div>
//             )}
//           </div>
//         )}

//         {activeTab === "Special Offer List" && (
//           <div>
//             <h2 className="text-2xl font-semibold text-gray-800 mb-4">Special Offer List</h2>

//             <div className="flex items-center gap-4 mb-4">
//               <div className="relative">
//                 <input
//                   type="text"
//                   placeholder="Search Special Offers..."
//                   value={searchQuery}
//                   onChange={handleSearch}
//                   className="p-3 lg:w-full sm:w-80 md:w-96 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
//                 />
//                 <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
//               </div>
//               <div className="flex items-center gap-1 sm:mt-0">
//                 <span>Show</span>
//                 <select
//                   value={entriesPerPage}
//                   onChange={handleEntriesChange}
//                   className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                   <option value="All">All</option>
//                 </select>
//                 <span>entries</span>
//               </div>
//             </div>

//             <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg hidden sm:table">
//               <thead>
//                 <tr className="text-left bg-gray-100">
//                   <th className="px-4 py-2 border-b">Offer</th>
//                   <th className="px-4 py-2 border-b">Special Offer Text</th>
//                   <th className="px-4 py-2 border-b">Coupon Type</th>
//                   <th className="px-4 py-2 border-b">Coupon Value</th>
//                   <th className="px-4 py-2 border-b">Expiry Date</th>
//                   <th className="px-4 py-2 border-b">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData.map((offer) => (
//                   <tr key={offer.id} className="border-b hover:bg-gray-50">
//                     <td className="px-4 py-2">{offer.id || ''}</td>
//                     <td className="px-4 py-2">{offer.special_text || ''}</td>
//                     <td className="px-4 py-2">{offer.coupon_type || ''}</td>
//                     <td className="px-4 py-2">{offer.coupon_value || ''}</td>
//                     <td className="px-4 py-2">{offer.coupon_date || ''}</td>
//                     <td className="px-4 py-2">
//                       <button
//                         onClick={() => handleEdit(offer, "specialOffer")}
//                         className="text-green-800 hover:text-green-700 mr-2"
//                       >
//                         <BiSolidEdit className="text-3xl" />
//                       </button>
//                       <button
//                         onClick={() => handleDelete(offer)}
//                         className="text-red-500 hover:text-red-700"
//                       >
//                         <RiDeleteBin5Line className="text-3xl" />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             <div className="flex items-center justify-between mt-4">
//               <div className="text-sm text-gray-600">
//                 <span>
//                   Showing {startIndex + 1} to {Math.min(startIndex + (entriesPerPage === "All" ? filteredData.length : parseInt(entriesPerPage)), filteredData.length)} of{" "}
//                   {filteredData.length} entries
//                 </span>
//               </div>
//               <div className="flex items-center gap-4">
//                 {entriesPerPage !== "All" && (
//                   <div className="flex items-center">
//                     <button
//                       onClick={handlePrevPage}
//                       disabled={currentPage === 1}
//                       className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
//                     >
//                       Previous
//                     </button>
//                     {[...Array(totalPages).keys()].map((page) => (
//                       <button
//                         key={`page-${page + 1}`}
//                         onClick={() => handlePageChange(page + 1)}
//                         className={`px-4 py-2 border ${currentPage === page + 1
//                             ? "bg-blue-500 text-white"
//                             : "bg-gray-200 hover:bg-gray-300"
//                           }`}
//                       >
//                         {page + 1}
//                       </button>
//                     ))}
//                     <button
//                       onClick={handleNextPage}
//                       disabled={currentPage === totalPages}
//                       className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
//                     >
//                       Next
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         {activeTab === "Edit" && editingItem && (
//           <div className="bg-white rounded-lg shadow-sm p-6">
//             <h2 className="text-2xl font-semibold text-gray-800 mb-6">
//               Edit {editingItemType === "promocode" ? "Promocode" : "Special Offer"}
//             </h2>
//             <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }} className="space-y-6">
//               {editingItemType === "specialOffer" && (
//                 <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
//                   <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
//                     Special Text
//                   </label>
//                   <input
//                     type="text"
//                     value={offerText}
//                     onChange={(e) => setOfferText(e.target.value)}
//                     className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
//                     placeholder="Enter special text"
//                     required
//                   />
//                 </div>
//               )}

//               <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
//                 <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
//                   Coupon Type
//                 </label>
//                 <select
//                   value={couponType}
//                   onChange={(e) => setCouponType(e.target.value)}
//                   className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration200"
//                   required
//                 >
//                   <option value="P">Percentage</option>
//                   <option value="F">Flat</option>
//                 </select>
//               </div>

//               <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
//                 <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
//                   Value
//                 </label>
//                 <input
//                   type="number"
//                   value={value}
//                   onChange={(e) => setValue(e.target.value)}
//                   className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
//                   placeholder="Enter value"
//                   required
//                 />
//               </div>

//               <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
//                 <label className="text-sm font-medium text-gray-700 w-full sm:w-36">
//                   {editingItemType === "specialOffer" ? "Coupon Date" : "Expiry Date"}
//                 </label>
//                 <input
//                   type="date"
//                   value={expiryDate}
//                   onChange={(e) => setExpiryDate(e.target.value)}
//                   className="px-4 py-2 border border-gray-300 rounded-lg w-full sm:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
//                   required
//                 />
//               </div>

//               <div className="pt-4">
//                 <button
//                   type="submit"
//                   className="px-6 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 transition-all duration-200 font-medium"
//                 >
//                   Update
//                 </button>
//               </div>
//             </form>
//           </div>
//         )}
//       </div>

//       {showDeleteConfirm && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 transform transition-all duration-300 scale-100">
//             <div className="p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                 Are you sure you want to delete this item?
//               </h3>
//               <div className="flex justify-end gap-4">
//                 <button
//                   onClick={() => setShowDeleteConfirm(false)}
//                   className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors duration-200"
//                 >
//                   Confirm
//                 </button>
//               </div>
//               {deleteApiResponse && (
//                 <div className={`mt-4 p-2 rounded ${deleteApiResponse.status === "true" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
//                   {deleteApiResponse.response}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Promocode_specialOffer;
    
    
    
    // import React, { useState } from "react";
    // import { CiSearch } from "react-icons/ci";
    // import { RiDeleteBin5Line } from "react-icons/ri";
    // import { BiSolidEdit } from "react-icons/bi";

    // const Promocode = () => {
    // const [activeTab, setActiveTab] = useState("VIEW SLOTS BY?");
    // const [searchQuery, setSearchQuery] = useState("");
    // const [entriesPerPage, setEntriesPerPage] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    // const [deleteCoupon, setDeleteCoupon] = useState(null);
  
    // const [couponCode, setCouponCode] = useState("");
    // const [couponType, setCouponType] = useState("");
    // const [value, setValue] = useState("");
    // const [limit, setLimit] = useState("");
    // const [expiryDate, setExpiryDate] = useState("");
    
    // // Sample promocode data
    // const promocodes = [
    //   { coupon: "Summer Discount", offer:"abc", text:"perr", code: "SUMMER2024", type: "Percentage", limit: 100 , used:1 ,value:200, date:"06-12-2024"},
    //   { coupon: "Winter Sale", offer:"npx",text:"ghg",code: "WINTER2024", type: "Flat" ,limit: 100 , value:200 , used:1,date: "06-12-2024"},
    //   { coupon: "Black Friday",offer:"hjh",text:"jkj",code: "BLACKFRIDAY", type: "Percentage" ,limit: 100 , value:200 ,used:1, date: "06-12-2024"},
    //   { coupon: "Cyber Monday", offer:"dfd", text:"uhu" ,code: "CYBERMONDAY", type: "Flat",limit: 100 , value:200 ,used:1, date: "06-12-2024" },
    //   { coupon: "Christmas Special", offer:"yty",text:"tht",code: "XMAS2024", type: "Percentage",limit: 100 , value:200 , used:1,date: "06-12-2024" },
    // ];
  
    // // Filtered data based on search query
    // const filteredData = promocodes.filter((promo) =>
    //   promo.coupon.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //   promo.offer.toLowerCase().includes(searchQuery.toLowerCase())
    // );
  
    // // Pagination logic
    // const startIndex = (currentPage - 1) * entriesPerPage;
    // const paginatedData = entriesPerPage === "All"
    //   ? filteredData
    //   : filteredData.slice(startIndex, startIndex + entriesPerPage);
  
    // const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  
    // // Handle search query
    // const handleSearch = (e) => setSearchQuery(e.target.value);
  
    // // Handle entries per page change
    // const handleEntriesChange = (e) => {
    //   setEntriesPerPage(e.target.value === "All" ? "All" : parseInt(e.target.value, 10));
    //   setCurrentPage(1); // Reset to first page
    // };
  
    // // Pagination handlers
    // const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    // const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    // const handlePageChange = (page) => setCurrentPage(page);
  
    // // Handle delete action
    // const handleDelete = (coupon) => {
    //   setDeleteCoupon(coupon);
    //   setShowDeleteConfirm(true);
    // };
  
    // // Confirm delete action
    // const confirmDelete = () => {
    //   console.log("Deleted coupon:", deleteCoupon);
    //   setShowDeleteConfirm(false);
    // };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log({
    //       couponCode,
    //       couponType,
    //       value,
    //       limit,
    //       expiryDate,
    //     });
    //     // You can also reset the form here if you want to clear the fields after saving
    //     setCouponCode("");
    //     setCouponType("");
    //     setValue("");
    //     setLimit("");
    //     setExpiryDate("");
    //   };

    // return (
    //     <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8 bg-white xl:px-52">
    //     {/* Tabs */}
    //     <div className="flex flex-nowrap justify-between border-b sm:border-b-4 md:border-b-8 border-gray-300 pb-4 mb-6 overflow-x-auto">
    //         <div className="flex flex-row w-full gap-2">
    //         {[
    //             "Promocodes",
    //             "Add New",
    //             "Add Special Offer",
    //             "Special Offer List",
                
    //         ].map((tab) => (
    //             <button
    //             key={tab}
    //             className={`flex-1 text-center px-2 sm:px-4 py-2 text-nowrap text-xs sm:text-sm font-medium rounded-lg transition-colors duration-300 ease-in-out ${
    //                 activeTab === tab
    //                 ? "bg-blue-500 border-b-4 border-blue-500 font-semibold text-white"
    //                 : "border-b-4 border-transparent text-gray-600 hover:text-blue-400 hover:border-blue-300 bg-slate-50"
    //             }`}
    //             onClick={() => setActiveTab(tab)}
    //             >
    //             {tab}
    //             </button>
    //         ))}
    //         </div>
    //     </div>

    //     {/* Tab Content */}
    //     <div className="p-2 sm:p-6">
    //         {/* VIEW SLOTS BY? Tab */}
    //         {activeTab === "Promocodes" && (
    //          <div>
    //          {/* Promocode Header */}
    //          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Promocodes</h2>
 
    //          {/* Search Bar and Show Dropdown */}
    //          <div className="flex items-center gap-4 mb-4 ">
    //          <div className="relative">
    //           <input
    //             type="text"
    //             placeholder="Search Staff..."
    //             value={searchQuery}
    //             onChange={handleSearch}
    //             className="p-3 lg:w-full sm:w-80 md:w-96   rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
    //           />
    //           <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
    //         </div>
    //            <div className="flex items-center gap-1 sm:mt-0">
    //              <span>Show</span>
    //              <select
    //                value={entriesPerPage}
    //                onChange={handleEntriesChange}
    //                className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
    //              >
    //                <option value={10}>10</option>
    //                <option value={25}>25</option>
    //                <option value={50}>50</option>
    //                <option value="All">All</option>
    //              </select>
    //              <span>entries</span>
    //            </div>
    //          </div>
 
    //          {/* Table */}
    //          <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg hidden sm:table">
    //            <thead>
    //              <tr className="text-left bg-gray-100">
    //                <th className="px-4 py-2 border-b">Coupon</th>
    //                <th className="px-4 py-2 border-b">Coupon Code</th>
    //                <th className="px-4 py-2 border-b">Coupon Type</th>
    //                <th className="px-4 py-2 border-b">Coupon Limit</th>
    //                <th className="px-4 py-2 border-b">Coupon Used</th>
    //                <th className="px-4 py-2 border-b">Coupon Value</th>
    //                <th className="px-4 py-2 border-b">Expiry Date</th>
    //                <th className="px-4 py-2 border-b">Action</th>
    //              </tr>
    //            </thead>
    //            <tbody>
    //              {paginatedData.map((promo, index) => (
    //                <tr key={index} className="border-b hover:bg-gray-50">
    //                  <td className="px-4 py-2">{promo.coupon}</td>
    //                  <td className="px-4 py-2">{promo.code}</td>
    //                  <td className="px-4 py-2">{promo.type}</td>
    //                  <td className="px-4 py-2">{promo.limit}</td>
    //                  <td className="px-4 py-2">{promo.used}</td>
    //                  <td className="px-4 py-2">{promo.value}</td>
    //                  <td className="px-4 py-2">{promo.date}</td>
                   
    //                  <td className="px-4 py-2">
    //                  <button
    //                     //  onClick={() => handleEdit(promo)}
    //                      className="text-green-800 hover:text-green-700"
    //                    >
    //                   <BiSolidEdit className="text-3xl" />
    //                    </button>
    //                    <button
    //                      onClick={() => handleDelete(promo)}
    //                      className="text-red-500 hover:text-red-700"
    //                    >
    //                    <RiDeleteBin5Line className="text-3xl" />
    //                    </button>
                       
    //                  </td>
    //                </tr>
    //              ))}
    //            </tbody>
    //          </table>
 
    //          {/* Delete Confirmation Modal */}
    //          {showDeleteConfirm && (
    //            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    //              <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
    //                <h3 className="text-lg font-semibold mb-4">Are you sure you want to delete this coupon?</h3>
    //                <div className="flex justify-end gap-4">
    //                  <button
    //                    onClick={() => setShowDeleteConfirm(false)}
    //                    className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
    //                  >
    //                    Cancel
    //                  </button>
    //                  <button
    //                    onClick={confirmDelete}
    //                    className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
    //                  >
    //                    Confirm
    //                  </button>
    //                </div>
    //              </div>
    //            </div>
    //          )}
 
    //          {/* Pagination Controls */}
    //          <div className="flex items-center justify-between mt-4">
    //            <div className="text-sm text-gray-600">
    //              <span>
    //                Showing {startIndex + 1} to {Math.min(startIndex + entriesPerPage, filteredData.length)} of{" "}
    //                {filteredData.length} entries
    //              </span>
    //            </div>
    //            <div className="flex items-center gap-4">
    //              {/* Pagination Controls */}
    //              {entriesPerPage !== "All" && (
    //                <div className="flex items-center">
    //                  <button
    //                    onClick={handlePrevPage}
    //                    disabled={currentPage === 1}
    //                    className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
    //                  >
    //                    Previous
    //                  </button>
    //                  {[...Array(totalPages).keys()].map((page) => (
    //                    <button
    //                      key={page + 1}
    //                      onClick={() => handlePageChange(page + 1)}
    //                      className={`px-4 py-2 border ${currentPage === page + 1
    //                        ? "bg-blue-500 text-white"
    //                        : "bg-gray-200 hover:bg-gray-300"
    //                        }`}
    //                    >
    //                      {page + 1}
    //                    </button>
    //                  ))}
    //                  <button
    //                    onClick={handleNextPage}
    //                    disabled={currentPage === totalPages}
    //                    className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
    //                  >
    //                    Next
    //                  </button>
    //                </div>
    //              )}
    //            </div>
    //          </div>
    //        </div>
    //         )}

    //         {/* AVAILABILITY Tab */}
    //         {activeTab === "Add New" && (
    //          <div>
    //          {/* Add New Promocode Header */}
    //          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Add New Promocode</h2>
 
    //          {/* Form (without form tag) */}
    //          <div className="space-y-4">
    //            {/* Coupon Code */}
    //            <div className="flex items-center gap-4">
    //              <label className="text-sm font-medium text-gray-600 w-36">Coupon Code</label>
    //              <input
    //                type="text"
    //                value={couponCode}
    //                onChange={(e) => setCouponCode(e.target.value)}
    //                className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //                placeholder="Enter coupon code"
    //                required
    //              />
    //            </div>
 
    //            {/* Coupon Type */}
    //            <div className="flex items-center gap-4">
    //              <label className="text-sm font-medium text-gray-600 w-36">Coupon Type</label>
    //              <select
    //                value={couponType}
    //                onChange={(e) => setCouponType(e.target.value)}
    //                className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //                required
    //              >
    //                <option value="">Select type</option>
    //                <option value="Percentage">Percentage</option>
    //                <option value="Flat">Flat</option>
    //              </select>
    //            </div>
 
    //            {/* Value */}
    //            <div className="flex items-center gap-4">
    //              <label className="text-sm font-medium text-gray-600 w-36">Value</label>
    //              <input
    //                type="number"
    //                value={value}
    //                onChange={(e) => setValue(e.target.value)}
    //                className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //                placeholder="Enter value"
    //                required
    //              />
    //            </div>
 
    //            {/* Limit */}
    //            <div className="flex items-center gap-4">
    //              <label className="text-sm font-medium text-gray-600 w-36">Limit</label>
    //              <input
    //                type="number"
    //                value={limit}
    //                onChange={(e) => setLimit(e.target.value)}
    //                className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //                placeholder="Enter limit"
    //                required
    //              />
    //            </div>
 
    //            {/* Expiry Date */}
    //            <div className="flex items-center gap-4">
    //              <label className="text-sm font-medium text-gray-600 w-36">Expiry Date</label>
    //              <input
    //                type="date"
    //                value={expiryDate}
    //                onChange={(e) => setExpiryDate(e.target.value)}
    //                className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //                required
    //              />
    //            </div>
 
    //            {/* Save Button */}
    //            <div>
    //              <button
    //                onClick={handleSubmit}
    //                className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-auto"
    //              >
    //                Save
    //              </button>
    //            </div>
    //          </div>
    //        </div>
    //      )}
 

    //         {/* ADD special offer Tab */}
    //         {activeTab === "Add Special Offer" && (
    //        <div>
    //         {/* Add New Promocode Header */}
    //         <h2 className="text-2xl font-semibold text-gray-800 mb-4">Add New Promocode</h2>

    //         {/* Form (without form tag) */}
    //         <div className="space-y-4">
    //           {/* Coupon Code */}
    //           <div className="flex items-center gap-4">
    //             <label className="text-sm font-medium text-gray-600 w-36">Coupon Code</label>
    //             <input
    //               type="text"
    //               value={couponCode}
    //               onChange={(e) => setCouponCode(e.target.value)}
    //               className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //               placeholder="Enter coupon code"
    //               required
    //             />
    //           </div>

    //           {/* Coupon Type */}
    //           <div className="flex items-center gap-4">
    //             <label className="text-sm font-medium text-gray-600 w-36">Coupon Type</label>
    //             <select
    //               value={couponType}
    //               onChange={(e) => setCouponType(e.target.value)}
    //               className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //               required
    //             >
    //               <option value="">Select type</option>
    //               <option value="Percentage">Percentage</option>
    //               <option value="Flat">Flat</option>
    //             </select>
    //           </div>

    //           {/* Value */}
    //           <div className="flex items-center gap-4">
    //             <label className="text-sm font-medium text-gray-600 w-36">Value</label>
    //             <input
    //               type="number"
    //               value={value}
    //               onChange={(e) => setValue(e.target.value)}
    //               className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //               placeholder="Enter value"
    //               required
    //             />
    //           </div>

    //           {/* Limit */}
    //           <div className="flex items-center gap-4">
    //             <label className="text-sm font-medium text-gray-600 w-36">Limit</label>
    //             <input
    //               type="number"
    //               value={limit}
    //               onChange={(e) => setLimit(e.target.value)}
    //               className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //               placeholder="Enter limit"
    //               required
    //             />
    //           </div>

    //           {/* Expiry Date */}
    //           <div className="flex items-center gap-4">
    //             <label className="text-sm font-medium text-gray-600 w-36">Expiry Date</label>
    //             <input
    //               type="date"
    //               value={expiryDate}
    //               onChange={(e) => setExpiryDate(e.target.value)}
    //               className="mt-1 px-4 py-2 border border-gray-300 rounded-lg w-64"
    //               required
    //             />
    //           </div>

    //           {/* Save Button */}
    //           <div>
    //             <button
    //               onClick={handleSubmit}
    //               className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-auto"
    //             >
    //               Save
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     )}


    //         {/* OFF TIME Tab */}
    //         {activeTab === "Special Offer List" && (
    //              <div>
    //              {/* Special Offer List Header */}
    //              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Special Offer List</h2>
     
    //              {/* Search Bar and Show Dropdown */}
    //              <div className="flex items-center gap-4 mb-4">
    //                <div className="relative">
    //                  <input
    //                    type="text"
    //                    placeholder="Search Offers..."
    //                    value={searchQuery}
    //                    onChange={handleSearch}
    //                    className="p-3 lg:w-full sm:w-80 md:w-96 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
    //                  />
    //                  <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
    //                </div>
    //                <div className="flex items-center gap-1 sm:mt-0">
    //                  <span>Show</span>
    //                  <select
    //                    value={entriesPerPage}
    //                    onChange={handleEntriesChange}
    //                    className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
    //                  >
    //                    <option value={10}>10</option>
    //                    <option value={25}>25</option>
    //                    <option value={50}>50</option>
    //                    <option value="All">All</option>
    //                  </select>
    //                  <span>entries</span>
    //                </div>
    //              </div>
     
    //              {/* Table */}
    //              <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg hidden sm:table">
    //                <thead>
    //                  <tr className="text-left bg-gray-100">
    //                    <th className="px-4 py-2 border-b">Offer</th>
    //                    <th className="px-4 py-2 border-b">Special Offer Text</th>
    //                    <th className="px-4 py-2 border-b">Coupon Type</th>
    //                    <th className="px-4 py-2 border-b">Coupon Value</th>
    //                    <th className="px-4 py-2 border-b">Offer Date</th>
    //                    <th className="px-4 py-2 border-b">Action</th>
    //                  </tr>
    //                </thead>
    //                <tbody>
    //                  {paginatedData.map((offer, index) => (
    //                    <tr key={index} className="border-b hover:bg-gray-50">
    //                      <td className="px-4 py-2">{offer.offer}</td>
    //                      <td className="px-4 py-2">{offer.text}</td>
    //                      <td className="px-4 py-2">{offer.type}</td>
    //                      <td className="px-4 py-2">{offer.value}</td>
    //                      <td className="px-4 py-2">{offer.date}</td>
    //                      <td className="px-4 py-2">
    //                        <button
    //                          className="text-green-800 hover:text-green-700"
    //                        >
    //                          <BiSolidEdit className="text-3xl" />
    //                        </button>
    //                        <button
    //                          onClick={() => handleDelete(offer)}
    //                          className="text-red-500 hover:text-red-700"
    //                        >
    //                          <RiDeleteBin5Line className="text-3xl" />
    //                        </button>
    //                      </td>
    //                    </tr>
    //                  ))}
    //                </tbody>
    //              </table>
     
    //              {/* Delete Confirmation Modal */}
    //              {showDeleteConfirm && (
    //                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    //                  <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
    //                    <h3 className="text-lg font-semibold mb-4">Are you sure you want to delete this offer?</h3>
    //                    <div className="flex justify-end gap-4">
    //                      <button
    //                        onClick={() => setShowDeleteConfirm(false)}
    //                        className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
    //                      >
    //                        Cancel
    //                      </button>
    //                      <button
    //                        onClick={confirmDelete}
    //                        className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
    //                      >
    //                        Confirm
    //                      </button>
    //                    </div>
    //                  </div>
    //                </div>
    //              )}
     
    //              {/* Pagination Controls */}
    //              <div className="flex items-center justify-between mt-4">
    //                <div className="text-sm text-gray-600">
    //                  <span>
    //                    Showing {startIndex + 1} to {Math.min(startIndex + entriesPerPage, filteredData.length)} of{" "}
    //                    {filteredData.length} entries
    //                  </span>
    //                </div>
    //                <div className="flex items-center gap-4">
    //                  {/* Pagination Controls */}
    //                  {entriesPerPage !== "All" && (
    //                    <div className="flex items-center">
    //                      <button
    //                        onClick={handlePrevPage}
    //                        disabled={currentPage === 1}
    //                        className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
    //                      >
    //                        Previous
    //                      </button>
    //                      {[...Array(totalPages).keys()].map((page) => (
    //                        <button
    //                          key={page + 1}
    //                          onClick={() => handlePageChange(page + 1)}
    //                          className={`px-4 py-2 border ${currentPage === page + 1
    //                            ? "bg-blue-500 text-white"
    //                            : "bg-gray-200 hover:bg-gray-300"
    //                            }`}
    //                        >
    //                          {page + 1}
    //                        </button>
    //                      ))}
    //                      <button
    //                        onClick={handleNextPage}
    //                        disabled={currentPage === totalPages}
    //                        className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
    //                      >
    //                        Next
    //                      </button>
    //                    </div>
    //                  )}
    //                </div>
    //              </div>
    //            </div>
    //          )}
    //     </div>
    //     </div>
    // );
    // };

    // export default Promocode;

